<template>
  <div ref="peserta">
    <m-card-list
      title="Peserta Kelas"
      search
      id-key
      :enroll="enroll && isCan('kelas-enrol') && maxPengguna"
      @enrollPeserta="enrollPeserta"
      @enrollPengelola="enrollPengelola"
      addText="Enrol"
      addHint="Enrol Peserta Kelas"
      filterPeran
      @filter="filter"
      refresh
      :variablePencarian="[
        { key: 'Nama', value: 'nama' },
        { key: 'Surel', value: 'surel' }
      ]"
      @refresh="load"
      :items="items"
      footerLabel="Pengguna"
      @search="
        search => {
          dataPencarian = search;
          load();
        }
      "
      :page="page"
      @change:page="
        pg => {
          cp = pg;
          load();
        }
      "
      footer
    >
      <template v-slot:filter>
        <v-divider></v-divider>
      </template>
      <template v-slot:items="{ item }">
        <v-row class="mx-3">
          <v-col cols="2" sm="2" md="1" lg="1" xl="1" class="d-none d-sm-flex" align="center" justify="center">
            <v-avatar :size="60" color="white">
              <v-icon size="50" color="primary">mdi-account-circle</v-icon>
            </v-avatar>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.smAndUp ? 12 : 10" sm="9" md="9" lg="10" xl="10">
            <v-row>
              <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                <p class="caption black--text my-0 py-0">Nama</p>
                <p class="body-1 font-weight-bold my-0 py-0">
                  {{ pVal(item, "name") }}
                </p>
                <p class="caption black--text my-0 py-0">Alamat Surel</p>
                <p class="blue--text caption">{{ pVal(item, "email") }}</p>
                <span v-if="item.peran_dapodik_id"
                  ><strong>{{ pVal(item.peran_dapodik, "keterangan") | toTitleCase }}</strong
                  ><br />
                  {{ item.nama_sekolah }}</span
                >
              </v-col>
              <v-col cols="12" sm="12" md="2" lg="2" xl="2">
                <p class="caption black--text my-0 py-0">Peran</p>
                <!-- <v-chip dark :color="$user.statusColor(item.kelasenrol[0].peran_kelas.id)">{{ item.kelasenrol[0].peran_kelas.keterangan | toTitleCase }}</v-chip> -->
                <p :class="$user.statusColor(item.kelasenrol[0].peran_kelas.id) + `--text font-weight-bold`">
                  {{ item.kelasenrol[0].peran_kelas.keterangan | toTitleCase }}
                </p>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3" xl="3">
                <div v-if="item.kelasenrol[0].peran_kelas.id == 1">
                  <p class="caption black--text my-0 py-0">Status</p>

                  <template v-if="item.kelasenrol[0].kelas.jenis.tag == 'registrasi'">
                    <p :class="item.kelasenrol[0].is_complete == 1 ? 'font-weight-bold success--text' : 'font-weight-bold error--text'">
                      {{ item.kelasenrol[0].is_complete == 1 ? "Lolos Verval" : "Tidak Lolos Verval" }}
                    </p>
                  </template>
                  <template v-else-if="is_daring">
                    <p
                      :class="
                        item.kelasenrol.length > 0 && !item.kelasenrol[0] && item.kelasenrol[0].is_complete ? 'font-weight-bold success--text' : 'font-weight-bold error--text'
                      "
                    >
                      {{ item.kelasenrol[0].is_complete == 1 ? "Tuntas" : "Belum Tuntas" }}
                    </p>
                    <p v-if="!item.kelasenrol[0] && item.kelasenrol[0].progress != null && item.kelasenrol[0].progress.length > 0">
                      {{ item.kelasenrol[0].progress[0].percentage }}%
                    </p>
                  </template>
                  <template v-else>
                    <p
                      :class="item.kelasenrol.length > 0 && item.kelasenrol[0].is_complete ? 'font-weight-bold success--text my-0 py-0' : 'font-weight-bold error--text my-0 py-0'"
                    >
                      {{ item.kelasenrol[0].is_complete == 1 ? "Tuntas" : "Belum Tuntas" }}
                    </p>
                    <p class="orange--text font-weight-bold my-0 py-0">Nilai: {{ item.kelasenrol[0].nilai_luring ? item.kelasenrol[0].nilai_luring : "Belum dinilai" }}</p>
                  </template>
                </div>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3" xl="3" v-if="item.kelasenrol[0].kelas.jenis.tag !== 'registrasi'">
                <p class="caption black--text my-0 py-0">Nilai</p>
                <p v-if="item.kelasenrol.length > 0">{{ item.kelasenrol[0].nilai_luring }}</p>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="1" sm="1" md="1" lg="1" xl="1">
            <p></p>
            <m-menu left style="float:right" :items="more_menu" :object="item" />
          </v-col>
        </v-row>
        <v-divider />
      </template>
    </m-card-list>
    <FormEnrollPeserta ref="pesertaDlg" />
    <FormEnrollPengelola ref="pengelolaDlg" />
    <FormNilai ref="nilaiDlg" :items="items" />
  </div>
</template>

<script>
import { isCan } from "@/tools";
import { PESERTA_COACHING_CLINIC } from "@/const";
import FormEnrollPeserta from "../components/FormEnrollPeserta.vue";
import FormEnrollPengelola from "../components/FormEnrollPengelola.vue";
import FormNilai from "../components/FormNilai.vue";
import FilterPengguna from "@/filter/FilterPengguna.vue";

// @group Global Feature
export default {
  name: "kelas-peserta",
  components: {
    FormEnrollPeserta,
    FormEnrollPengelola,
    FormNilai,
    FilterPengguna
  },
  data() {
    return {
      items: [],
      textSearch: null,
      dataPencarian: null,
      page: null,
      cp: 1,
      jumlahPengguna: 0,
      more_menu: [
        {
          title: "Unenroll",
          icon: "mdi-account-cancel",
          color: "orange",
          click: (i, o) => this.unenroll(o),
          check: () => isCan("kelas-enrol")
        }
      ]
    };
  },
  computed: {
    headers() {
      const a = [
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", sortable: false }
      ];
      return a;
    },
    maxPengguna() {
      return this.jumlahPengguna > PESERTA_COACHING_CLINIC ? false : true;
    }
  },
  activated() {
    this.load();
  },
  mounted() {
    this.load();
  },
  props: {
    enroll: {
      type: Boolean,
      default: false
    },
    is_kelas_tutup: {
      type: Boolean,
      default: false
    },
    is_daring: {
      type: Boolean,
      default: false
    },
    is_nilai: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    load() {
      var params = {
        page: this.cp,
        peran_kelas: this.peran
      };
      if (this.dataPencarian) {
        var param = this.dataPencarian.param == "surel" ? "email" : this.dataPencarian.param;
        params[param] = this.dataPencarian.s;
      }
      return this.$store
        .dispatch("kelas/getPesertaKelas", {
          instansi_id: this.instansi_id,
          kelas_id: this.kelas_id,
          params: params
        })
        .then(res => {
          this.page = res;
          this.jumlahPengguna = res.total;
          this.items = res.data;
        })
        .catch(e => e);
    },
    pencarian() {
      this.cp = 1;
      this.current_page = 1;
      this.load();
    },
    filter(data) {
      this.peran = data.peran;
      this.load();
    },
    toNilai() {
      this.$refs.nilaiDlg.open().then(() => {
        this.load();
      });
    },
    enrollPeserta() {
      this.$refs.pesertaDlg.open().then(() => {
        this.load();
      });
    },
    enrollPengelola() {
      this.$refs.pengelolaDlg.open().then(() => {
        this.load();
      });
    },
    unenroll(item) {
      var objUser = [];
      objUser.push(item);
      this.$confirm(
        `Apakah Anda yakin akan mengeluarkan akun ini dari kelas?<br>
        <div class="mt-2 title grow text-center">
          ${item.name}<br>
        </div>`
      )
        .then(() => this.$store.dispatch("kelas/unenroll", { instansi_id: this.instansi_id, kelas_id: this.kelas_id, obj: objUser }))
        .then(() => {
          this.$info("Akun " + item.name + " berhasil dikeluarkan dari kelas");
        })
        .then(() => this.load())
        .catch(e => e);
    }
  }
};
</script>
